import {twMerge} from '@sdox/utils'

import {StoreCard} from './StoreCard'

import type {ComponentProps} from 'react'

export interface AppDownloadProps extends ComponentProps<'div'> {
  /** the apple store link */
  appstoreUrl?: string
  /** the play store link */
  playstoreUrl?: string
}

export const AppDownload = ({
  appstoreUrl,
  playstoreUrl,
  className,
  ...restProps
}: AppDownloadProps) => (
  <div className={'@container/block'}>
    <div
      className={twMerge(
        'flex flex-col items-stretch rounded-radius-md',
        'divide-y-1 divide-outline-secondary border-1 border-outline-secondary',
        '@[780px]:flex-row @[780px]:divide-x-1 @[780px]:divide-y-0',
        className,
      )}
      {...restProps}
    >
      {appstoreUrl && (
        <StoreCard
          storeUrl={appstoreUrl}
          store={'apple-store'}
        />
      )}
      {playstoreUrl && (
        <StoreCard
          storeUrl={playstoreUrl}
          store={'play-store'}
        />
      )}
    </div>
  </div>
)
